module.exports = __webpack_public_path__ + "img/6.f430a73e.png";